<template>
  <Preloader v-if="isLoading" />
  <div v-else id="demosmvoptions">
    <AssetsControl />
    <OptionsControl />
    <ViewerControl />
    <transition name="fade">
      <ModalAddAssets v-show="statusAssetsForm" />
    </transition>
    <transition name="fade">
      <ModalInfo v-show="errorLoadConfigStatus" />
    </transition>
    <transition name="fade">
      <ModalSpinControlPanel v-show="spinControlModalStatus" />
    </transition>
    <notifications :duration="-1" :ignore-duplicates="true" position="bottom right" />
  </div>
</template>

<script>
import AssetsControl from "@/components/AssetsControl";
import OptionsControl from "@/components/OptionsControl";
import ViewerControl from "@/components/ViewerControl";
import ModalAddAssets from "@/components/ModalAddAssets";
import ModalInfo from "@/components/ModalInfo";
import ModalSpinControlPanel from "@/components/ModalSpinControlPanel";
import Preloader from "@/widgets/common/Preloader";
import { loadSirv } from "@/utils/load-sirv";
import { mapGetters, mapState } from "vuex";

export default {
  name: "App",
  components: {
    Preloader,
    AssetsControl,
    OptionsControl,
    ViewerControl,
    ModalAddAssets,
    ModalInfo,
    ModalSpinControlPanel,
  },
  props: {
    options: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: true,
      value: 0,
    };
  },
  computed: {
    ...mapState({
      statusAssetsForm: (state) => state.statusAssetsForm,
      initDataLoaded: (state) => state.initDataLoaded,
      errorLoadConfigStatus: (state) => state.config.errorLoadConfigStatus,
      spinControlModalStatus: (state) => state.spinControl.spinControlModalStatus,
    }),
  },
  created() {
    loadSirv("")
      .then(() => {
        window.Sirv.whenReady(() => {
          window.Sirv.start();
          const savingMode = this.$localStorage.get("tabsmode") || "inline";
          setTimeout(() => {
            const query = Object.keys(this.$route.query).length !== 0 ? this.$route.query : null;
            if (query !== null) {
              this.$store.dispatch("initData");
              setTimeout(() => {
                this.$store.dispatch("changeClearOptions", false);
                this.$store.dispatch("changeClearOptionsCSS", false);
                this.$store.dispatch("changeClearOptionsJS", false);
                this.$store.dispatch("changeExample", {
                  type: "default",
                  query: query,
                });
              }, 1000);
            } else {
              this.$store.dispatch("initData");
            }

            this.$store.dispatch("changeMode", savingMode);
          }, 500);
        });
      })
      .catch((e) => console.error("Something went wrong.", e));

    this.unwatch = this.$store.watch(
      (state) => state.initDataLoaded,
      (value) => {
        if (value?.status !== null) {
          this.isLoading = false;
        }
        if (value !== undefined && value.hasOwnProperty("status") && value.status === false) {
          this.$notify({
            type: "error",
            title: value.title,
            text: value.text,
          });
        }
      }
    );
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400&display=swap");

.el-collapse-item__wrap {
  overflow: visible;
}

.control__helper {
  .hint a {
    color: inherit;
  }
}

#demosmvoptions {
  font-family: "Source Sans Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 1440px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px auto;
  position: relative;
  align-items: center;

  @media only screen and (min-width: 992px) {
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
.vue-notification {
  font-size: 14px !important;
  &.success {
    background: #327bba !important;
    border-left-color: #509ad9 !important;
  }
}

.smv-h .smv-arrow {
  position: relative;
  transition: opacity 0.2s ease;
  opacity: 0.000001;

  &::before,
  &::after {
    display: block;
    content: "";
    position: absolute;
    background-color: transparent;
    border: 3px solid transparent;
    border-radius: 5px 5px 0 0;
    height: 22%;
    top: 50%;
    right: 25%;
    transform: translate(-50%, -99.2%) skewX(40deg);
    width: 4px;
    z-index: 1;
    box-sizing: content-box !important;
  }

  &::before {
    border-bottom: none;
  }

  &::after {
    border-top: none;
    transform: translate(-50%, -0.8%) skewX(-40deg);
    border-radius: 0 0 5px 5px;
  }

  &.smv-arrow-thumbnails {
    opacity: 1;
    &::before,
    &::after {
      display: none;
    }

    .smv-icon {
      &::before,
      &::after {
        right: 2px;
      }
    }
  }
}

.smv-arrow .smv-icon {
  -webkit-mask-repeat: none !important;
  mask-repeat: none !important;
  -webkit-mask-position: none !important;
  mask-position: none !important;
  -webkit-mask-size: none !important;
  -webkit-mask-image: none !important;
  background: transparent !important;
  z-index: 2;
  position: static !important;
  &::before,
  &::after {
    display: block;
    content: "";
    position: absolute;
    background: #999;
    border-radius: 5px 5px 0 0;
    height: 22%;
    top: 50%;
    right: 25%;
    transform: translate(-50%, -99.2%) skewX(40deg);
    width: 5px;
    z-index: 2;
    margin: 0 4px;
  }

  &::before {
    border-bottom: none;
  }

  &::after {
    border-top: none;
    transform: translate(-50%, -0.8%) skewX(-40deg);
    border-radius: 0 0 5px 5px;
  }
}
.smv-h .smv-arrow-prev .smv-icon {
  transform: none !important;
}

.smv-h .smv-arrow-prev.smv-arrow {
  transform: scaleX(-1) !important;
}

.smv-arrow .smv-icon {
  opacity: 1 !important;
}

.smv-slides-box:hover .smv-arrow {
  opacity: 0.4 !important;
}

.smv-slides-box:hover .smv-arrow:hover {
  opacity: 1 !important;
}

@media screen and (max-width: 768px) {
  .smv-h .smv-arrow {
    opacity: 1 !important;
  }

  .smv-slides-box:hover .smv-arrow {
    opacity: 1 !important;
  }
}
</style>
